import { call, put, takeEvery } from "redux-saga/effects";
import {
  loginSucess,
  loginFailed,
  signUpSuccess,
  signUpFailed,
  putSettingsSuccess,
  putSettingsFailed,
} from ".";
import { message } from "antd";
import Cookies from "js-cookie";
import { serverIp } from "../../../utils";
import keycloak from "../../../Keycloak";

export function* signInUser({ payload }: any): any {
  const { email, password } = payload;
  const requestUrl = `${serverIp}/login`;
  const loginPayload = {
    email: email,
    password: password,
  };
  try {
    // Send JSON data in the request body
    const data = yield call(() =>
      fetch(requestUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginPayload),
      })
    );

    const parsedData = yield data.json();
    message.success("Login Successfull");
    Cookies.set("userData", JSON.stringify(parsedData));
    yield put(loginSucess(parsedData));
  } catch (err) {
    message.error("Login Failed");
    yield put(loginFailed());
  }
}

export function* signUpUser({ payload }: any): any {
  const { email, password } = payload;
  const requestUrl = `${serverIp}/signup`;
  const loginPayload = {
    email: email,
    password: password,
  };
  try {
    // Send JSON data in the request body
    const data = yield call(() =>
      fetch(requestUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginPayload),
      })
    );

    const parsedData = yield data.json();
    message.success("Account created Successfully!");
    yield put(signUpSuccess(parsedData));
  } catch (err) {
    message.error("Account creation failed!");
    yield put(signUpFailed());
  }
}

export function* putUserSettings({ payload }: any): any {
  const requestUrl = `${serverIp}/settings`;
  try {
    const data = yield call(() =>
      fetch(requestUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${keycloak.token}`,
        },
        body: JSON.stringify(payload),
      })
    );
    const parsedData = yield data.json();
    message.success("Settings Saved Successfully!");
    Cookies.set("userData", JSON.stringify(parsedData));
    yield put(putSettingsSuccess(parsedData));
  } catch (err) {
    message.error("Save failed!");
    yield put(putSettingsFailed());
  }
}

function* userSaga() {
  yield takeEvery("loginApi/checkLogin", signInUser);
  yield takeEvery("loginApi/putSettings", putUserSettings);
  yield takeEvery("loginApi/checkSignUp", signUpUser);
}

export default userSaga;
